<div class="map-content-layout">
  <div
    class="map-container item"
    [ngClass]="{ 'full-width': !showGraph }"
    [hidden]="fullScreenGraphs"
  >
    <div class="map-content">
      <div id="comparison-container" #comparison [ngClass]="{'half-creen': !showGraph,}">
        <div id="before" class="map" [ngClass]="{'afterMap':showAfterMap}"></div>
        <div id="after" class="map"></div>
      </div>

      <app-menu-bottom
        *ngIf="!showGraph"
        (showMenu)="setShowMenu($event)"
        (timeRange)="timeRange = $event"
        (showModal)="alert = $event"
        (showSelected)="selectedLayers = $event"
        (timeMoment)="timeMoment = $event"
        
      ></app-menu-bottom>
      <app-map-date-picker
        [showMenu]="showMenu['periodos']"
        [timeRange]="timeRange"
        [timeMoment]="timeMoment"
        [minValue]="periodDate"
        (minDateEvent)="periodDate = $event"
        (maxDateEventRange)="setRangeDate($event, 'end')"
        (minDateEventRange)="setRangeDate($event)"
        (closeEvent)="showMenu['periodos'] = $event"
        
      ></app-map-date-picker>
      <app-map-styles-menu
        [fullScreen]="showGraph"
      ></app-map-styles-menu>
      <app-sidebar
        [showDatePicker]="showMenu['periodos']"
        [showMenu]="showSideBar"
        [showGraph]="showGraph"
        [rangeDate]="rangeDate"
        [periodDate]="periodDate"
        [wellList]="wellList"
        [treeList]="treeList"
        (layersSelected)="layersSelected = $event"
        (layersSelectedCompare)="layersSelectedCompare = $event"
        (graphEvent)="showGraph = $event"
        (timeRange)="timeRange = $event"
        (timeMoment)="timeMoment = $event"
        (fullScreenGraphs)="fullScreenGraphs = $event"
        (closeEvent)="showSideBar = $event"
        (closeEventRange)="showMenu['periodos'] = $event"
        (labelGraph)="showLGraph($event)"
        (searchZone)="searchZone()"
        (dmuSelected)="dmuSelected = $event"
        (periodDateC)="periodDateC = $event"
        (minDateEventC)="momentDateC = $event"
        (timeRangeC)="timeRangeC = $event"
        (timeMomentC)="timeMomentC = $event"
        (minDateEventRange) = "rangeDateSend = $event"
        (maxDateEventRange) = "rangeDateSendCompare = $event"
      ></app-sidebar>
      <!-- <app-field-list
        [showMenu]="showMenu['fields']"
        (closeEvent)="showMenu['fields'] = $event"
      ></app-field-list> -->
      <div class="buttons-container" [ngClass]="{ 'buttons-container-reduce': showGraph }">
        <div class="comparator">
          <div class="map-a" *ngIf="timeRange && rangeDateSend !== undefined || timeMoment && rangeDateSend !== undefined">
            <div>Filtros aplicados</div>
            <div *ngIf="timeRange">{{rangeDateSend?.start_date | date : "mediumDate" | titlecase }}  -  {{rangeDateSend?.end_date  | date : "mediumDate" | titlecase}}</div>
            <div *ngIf="timeMoment">{{rangeDateSend?.period_date | date: "MMM y" | titlecase}}</div>
          </div>
          <div class="map-b" *ngIf="timeRangeC && rangeDateSendCompare !== undefined || timeMomentC && rangeDateSendCompare !== undefined">
            <div>Filtros aplicados</div>
            <div *ngIf="timeRangeC">{{ rangeDateSendCompare?.start_date | date : "mediumDate" | titlecase}}  -  {{rangeDateSendCompare?.end_date | date : "mediumDate" | titlecase}}</div>
            <div *ngIf="timeMomentC">{{rangeDateSendCompare?.period_date  | date: "MMM y" | titlecase}}</div>
          </div>
        </div>
        <!-- <ion-button [routerLink]="['/field-list']" class="btn-back"
          ><ion-icon slot="start" name="arrow-back-circle-outline"></ion-icon
        ></ion-button> -->
       
        <ion-button
          color="danger"
          (click)="searchZone()"
          class="btn-search-zone"
          *ngIf="_mapService.showSearchZone"
          ><ion-icon slot="start" name="search"></ion-icon>Filtrar en esta área
        </ion-button>
        <div></div>
        <ion-toast
        *ngIf="!fullScreenGraphs"
          color="danger"   
          [isOpen]="isToastOpen"
          [message]="message"
          [duration]="5000"
          (didDismiss)="setOpen(false)"
        ></ion-toast>
      </div>
    </div>
  </div>
  <div
    class="graphs-content item"
    *ngIf="showGraph"
    [ngClass]="{ 'background-content-default': fullScreenGraphs }"
  >
    <app-graph
      [labelListGraph]="labelGraph"
      [wellList]="wellList"
      [dmuSelected] = "dmuSelected"
      [rangeDate]="rangeDate"
      [isOpenToast]="true"
      (closeEvent)="showGraph = $event"
      (fullScreenGraphEvent)="fullScreenGraphs = $event"
    ></app-graph>

  </div>
  <app-notifications-modal *ngIf="alert"
  (showModal)="alert = $event"></app-notifications-modal>
  <app-layers-selected *ngIf="selectedLayers"
  (showSelected)="selectedLayers = $event"
  [layers]="layersSelected"
  [layersCompare]="layersSelectedCompare"></app-layers-selected>
</div>

<!-- <button (click)="update3dTest()" style="position: absolute;z-index: 99999;right: 0;">3d Test</button> -->
